import * as React from "react"
import PropTypes from "prop-types"
import { Slot } from "@radix-ui/react-slot"
import { cva } from "class-variance-authority";

import { cn } from "@/lib/utils"

const badgeVariants = cva(
  "inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
  {
    variants: {
      variant: {
        default:
          "border-transparent bg-primary text-primary-foreground shadow",
        secondary:
          "border-transparent bg-secondary text-secondary-foreground",
        destructive:
          "border-transparent bg-destructive text-destructive-foreground shadow",
        outline: "text-foreground",
        outlineGray: "text-foreground border-gray-300 bg-gray-100",
        brandPrimary:
          "border-transparent bg-brand-primary text-white",
        brandSecondary:
          "border-transparent bg-brand-secondary text-white",
        brandError:
          "border-transparent bg-brand-error text-white",
        warningOrange:
          "border-transparent bg-orange-500 text-white",
        muted:
          "border-transparent bg-gray-400 text-white",
        info:
          "border-transparent bg-info text-white",
        warning:
          "border-transparent bg-yellow-500 text-white",
        success:
          "border-transparent bg-primary text-primary-foreground shadow",
        dark:
          "border-transparent bg-gray-700 text-white",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
)

const Badge = React.forwardRef(({ className, variant, asChild = false, ...props }, ref) => {
  const Comp = asChild ? Slot : "div";

  return (
    <Comp ref={ref} className={cn(badgeVariants({ variant }), className)} {...props} />
  );
});
Badge.displayName = "Badge";

Badge.propTypes = {
  variant: PropTypes.string,
  className: PropTypes.string,
  asChild: PropTypes.bool,
};

export { Badge }
